import { COMPANY } from "@/lib/contact";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="border-t border-border py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="flex items-center gap-3 text-foreground">
          <Logo />
          <span className="text-xs text-muted-foreground border-l border-border pl-3 ml-1">
            BRN {COMPANY.brn}
          </span>
        </div>
        <div className="text-muted-foreground md:text-right">
          <p className="text-sm">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-sm mt-1">A sister company of ProMEP Ltd.</p>
        </div>
      </div>
    </footer>
  );
}
